import { Outlet } from '@solidjs/router';
import ProvideSelectedOrganization from './ProvideSelectedOrganization';
const ProvideSelectedOrganizationToRoutes = () => (<ProvideSelectedOrganization>
    <Outlet />
  </ProvideSelectedOrganization>);
export default ProvideSelectedOrganizationToRoutes;
